import { notifications } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import {
  INotificationCount,
  INotificationData,
  INotifications,
} from "../../models/master/notification";

export default new (class NotificationService {
  public getNotification = async (
    id: number
  ): Promise<IApiResponse<INotificationData>> => {
    try {
      let endPoint = urlBinder(notifications.GET_NOTIFICATION, [`${id}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<INotificationData>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<INotificationData>;
      } else {
        throw error;
      }
    }
  };

  public getNotifications = async (
    configUserRole?: number,
    pageBlock?: number,
    departmentId?: number,
    collegeId?:number,
    noOfItems?: number,
    notificationTypeId?: number,
    pageNumber?: number
  ): Promise<IApiResponse<Array<INotifications>>> => {
    try {
      let endPoint = urlBinder(notifications.GET_ALL_NOTIFICATIONS, [
        configUserRole,
        pageBlock,
        departmentId,
        collegeId,
        noOfItems,
        notificationTypeId,
        pageNumber,
      ]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<INotifications>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<INotifications>>;
      } else {
        throw error;
      }
    }
  };

  public createNotification = async (
    data: any
  ): Promise<IApiResponse<boolean | any>> => {
    try {
      let endPoint = notifications.CREATE_NOTIFICATION;
      const response = await APIService.postFormData(endPoint, data);
      return response.data as IApiResponse<boolean | any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean | any>;
      } else {
        throw error;
      }
    }
  };

  public updateNotification = async (
    data: any,
    id: number
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = urlBinder(notifications.UPDATE_NOTIFICATION, [`${id}`]);
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public updateNotificationPriority = async (
    data: any
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = notifications.UPDATE_NOTIFICATION_PRIORITY;
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public deleteNotification = async (id: number): Promise<boolean> => {
    try {
      let endPoint = urlBinder(notifications.DELETE_NOTIFICATION, [`${id}`]);
      const response = await APIService.delete(endPoint);
      return response.status === 204 ? true : false;
    } catch (error: any) {
      if (error.response) {
        return false as boolean;
      } else {
        throw error;
      }
    }
  };

  public getNotificationType = async (): Promise<
    IApiResponse<Array<INotifications>>
  > => {
    try {
      let endPoint = notifications.GET_NOTIFICATION_TYPE;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<INotifications>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<INotifications>>;
      } else {
        throw error;
      }
    }
  };
  public updateNotificationStatus = async (
    data: any
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = notifications.UPDATE_NOTIFICATION_STATUS;
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };
  public notificationCount = async (
    configUserType?: number,
    notificationTypeId?: number
  ): Promise<IApiResponse<INotificationCount>> => {
    try {
      let endPoint = urlBinder(notifications.GET_NOTIFICATION_COUNT, [
        configUserType,
        notificationTypeId,
      ]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<INotificationCount>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<INotificationCount>;
      } else {
        throw error;
      }
    }
  };
})();
